<template>
  <div>
    <Header v-on:setWebInfo="setWebInfo" v-on:turn="getRec" :mobileCircleFetId="mobileCircleFetId"
      :isAiApiFetch="isAiApiFetch" :siteData="siteData" />
    <div class="turn-body">
      <div class="turn-body__head">
        <img src="@/assets/homepage_guide.svg" />
      </div>
      <ul :class="['cupn-items', { 'desktop-iframe': isDesktopIframe }]" id="discount_list">
        <li v-if="isShowUpPromotion && isPromotionImageExsited"
          :class="['cupn-item', 'cupn-item__promotion', { 'roll-in-left': isAiApiFetch }]">
          <img :src="promotionImage" />
        </li>
        <li v-for="(item, index) of items" :key="index" :class="['cupn-item-parent', { 'swipe-text': item.swipeHint }]">
          <Item :item="item" :isAiApiFetch="isAiApiFetch" :trackCode="trackCode" :isMobile="isMobile"
            :isScrolling="isScrolling" :isShowPidRec="isShowPidRec" :mobileCircleFetId="mobileCircleFetId"
            v-on:revertRecItems="revertRecItems" v-on:getCategoryRec="getCategoryRec" />
        </li>
        <li v-if="isShowBottomPromotion && isPromotionImageExsited"
          :class="['cupn-item', 'cupn-item__promotion', { 'roll-in-left': isAiApiFetch }]">
          <img :src="promotionImage" />
        </li>
      </ul>
    </div>
    <div v-if="!isDesktopIframe" class="turn-footer">
      <div>
        <a href="https://ec-m.shopping.friday.tw" target="_blank">遠傳friDay購物＞</a>
      </div>
      <div>
        <a href="#" @click="turn($event, 'bottom')">
          <img src="@/assets/turnturn_click.svg" />
        </a>
      </div>
      <div>
        <a :href="checkOrderUrl" target="_blank">查訂單</a>
      </div>
    </div>
    <div class="turn-winner" v-if="winner && !isBsite">
      <div class="turn-winner__container">
        <div class="turn-winner__name">恭喜 {{ winner.consumerName }} ({{ winner.consumerTel }}) 轉出{{ winner.cash }}元
        </div>
        <div class="turn-winner__sku">{{ winner.productName }}</div>
        <router-link :to="winnerPath">幸運名單＞</router-link>
      </div>
    </div>
    <Footer v-if="!isDesktopIframe" />

  </div>
</template>

<script>
import Header from "./components/header.vue";
import Footer from "./components/footer.vue";
import Item from "./components/item.vue";

export default {
  name: "Homepage",
  components: {
    Header,
    Footer,
    Item,
  },
  data() {
    return {
      isBsite: false, // 是否為B型網站
      siteData: {}, // B型網站資料
      items: [],
      originItems: [], // 原來的商品資料
      originFlaghs: "", // 原來的AI HS
      postData: {
        // "method": "getqpage",
        target: "pseudoid",
        list_fun: "Q3sTT",
        list_args: "content",
        list_remote: "lots_m",
        list_cmpn: "friday00",
        list_click: 0,
      },
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "X-Requested-With": null,
      },
      winner: null,
      isMobile: /mobi(li)?/i.test(navigator.userAgent),
      isAiApiFetch: false, // 預設API是否載入完成
      isLoadPidAI: false, // 特定PID的API是否載入完成
      isShowPidRec: false, // 目前是否顯示特定PID的UI
      isShowUpPromotion: false, // 是否有第一中獎品
      isShowBottomPromotion: false, // 是否有最後中獎品
      isPromotionImageExsited: false, // 是否Promotion圖片存在
      isDesktopIframe: false, // 是否被PC崁了IFRAME
      aipcParams: "friday",
      promotionImage: "",
      trackCode: "turnturn_AI",
      isScrolling: false,
      windowY: 0,
      mobileCircleFetId: null, // 心生活FetId,
      productPageUrl: 'https://ec-m.shopping.friday.tw/product/'
    };
  },
  async created() {
    // export vue router
    window["vue_router"] = this.$route;
    let { partnerCode, partnerName } = this.$route.params;

    if (partnerName) {
      if (/\d{2}$/.test(partnerName)) {
        partnerName = partnerName.replace(/\d{2}$/, "");
      }

      this.aipcParams = partnerName;
      this.postData.list_cmpn = partnerName;

      if (partnerCode) {
        this.postData.list_cmpn += partnerCode;
        this.aipcParams = partnerCode + "/" + partnerName;
      } else {
        this.postData.list_cmpn += "00";
        this.aipcParams = "00/" + partnerName;
      }
    }

    // === url search check ===
    const { fp, mc_w, mc_s, supplierId } = this.$route.query;

    if (supplierId) {
      const bData = await this.getBSiteData(supplierId);
      if (bData && bData.supplierId) {
        this.isBsite = true;
        this.siteData = bData;
        console.log(bData);
      }
    }

    // 指定PID為第一品
    if (fp) {
      this.postData.list_click = fp;
    }

    // 心生活取得加密文，換取fetId
    if (mc_w && mc_s) {
      this.getMobileCircleFetId(mc_w, mc_s);
    }

    // === End url search check ===

    // 是否為LINE in-app browser
    let href = window.location.href;
    const u = navigator.userAgent;
    const isLineApp = u.indexOf("Line") > -1; // Line 內建瀏覽器

    if (isLineApp) {
      if (href.indexOf("openExternalBrowser") < 0) {
        href = href.replace("#/", "");

        // 網址沒有參數 ? 時, 直接加參數
        if (href.indexOf("?") < 0) {
          href += "?openExternalBrowser=1";
        } else {
          // 網址有參數 ? 時, 用 & 加參數
          href += "&openExternalBrowser=1";
        }
        window.location.href = href;
      }
    }

    // 是否來自大網崁IFRAME
    if (/d=1/i.test(location.search)) {
      this.isDesktopIframe = true;
    }

    // 檢查字卡是否存在
    let defaultCard = "promotion";
    if (partnerName) {
      defaultCard = partnerName;
    }
    const defaultCardPath = this.promotionCard(defaultCard);
    const cardImage = new Image();
    cardImage.onload = () => {
      this.promotionImage = defaultCardPath;
      this.isPromotionImageExsited = true;
    };
    cardImage.onerror = () => {
      console.log('promotion image non-exsited!');
      // this.promotionImage = this.promotionCard("promotion");
    };
    cardImage.src = defaultCardPath;

    // 取得轉轉資料
    const gaCookie = this.$cookies.get("_ga");
    this.postData["target_value"] = gaCookie
      ? gaCookie.match(/(\d+)\.(\d+)$/gi)[0]
      : 0;
    // this.postData["nw"] = navigator.webdriver
    if (!window.sessionStorage.getItem("tempPidItems")) {
      this.getRec();
    }

    // 取得得獎資料
    if (!this.isBsite) {
      this.winnerApi
        .getWinnerList()
        .then((res) => {
          this.winner = res && res.data ? res.data[0] : null;
        })
        .catch(() => {
          this.winner = null;
        });
    }

    // 監聽window scroll
    let scrollTimer = null;
    window.addEventListener(
      "scroll",
      () => {
        this.isScrolling = true;

        if (scrollTimer !== null) {
          clearTimeout(scrollTimer);
        }
        scrollTimer = setTimeout(() => {
          this.isScrolling = false;
        }, 250);
      },
      {
        passive: false,
      }
    );
  },
  mounted() {
    // 預防手機回上一頁，抽獎的獎項沒有清空，則再取得一次
    const ua = navigator.userAgent;
    if (/mobile/i.test(ua)) {
      if (/iphone/i.test(ua)) {
        window.onpopstate = () => {
          this.getRec();
        };
      } else {
        setInterval(() => {
          if (window.sessionStorage.getItem("bsBack")) {
            this.getRec();
            window.sessionStorage.removeItem("bsBack");
          }
        }, 1000);
      }
    }
  },
  methods: {
    //取得bsite資料
    async getBSiteData(supplierId) {
      return await fetch(
        `https://front.shopping.friday.tw/frontendapi/bWeb/config?supplierId=${supplierId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
        .then((res) => res.json())
        .then((res) => {
          if (
            res &&
            res.resultData &&
            typeof res.resultData === "object" &&
            res.resultData.length > 0
          ) {
            return res.resultData[0];
          }
        })
        .catch((err) => {
          console.error(`getSiteId faliure`);
          console.error(err);
        });
    },
    setWebInfo(data) {
      if (data.trackCode) {
        this.trackCode = data.trackCode;
      }
    },
    turn(evt, pos) {
      evt.preventDefault();
      this.getRec();
      if (pos === "bottom") {
        window.scrollTo({
          top: 0,
        });
      }
    },

    getRec() {
      if (!this.isBsite) {
        this.getQpageRec();
      } else {
        this.getAi4Rec();
      }
    },

    getAi4Rec() {
      if (this.isAiApiFetch) {
        return false;
      }

      this.isAiApiFetch = true;

      setTimeout(() => {
        this.isAiApiFetch = false;
      }, 1500);

      this.postData['site_id'] = this.siteData.siteId;

      fetch(`${this.configs.mserviceApiPath}FetchTurn/getTurnData`, {
        method: "POST",
        headers: this.headers,
        body: JSON.stringify(this.postData),
      })
        .then((res) => res.json())
        .then((json) => {
          const { data, payload } = json;

          this.items = data.map((v) => {
            return Object.assign(v, {
              image_url: v.image_url || '',
              url: `/${this.siteData.urlSuffix}/product/${v.pid}`,
              swipeHint: false,
              after_discount: v.price - v.discount
            });
          });
          const cookieDomain = window.location.hostname;
          document.cookie = `AI_TN=${payload};path=/;max-age=86400;domain=${cookieDomain};`;
        });
    },

    async getQpageRec() {
      if (this.isAiApiFetch) {
        return false;
      }

      this.isShowPidRec = false;
      this.isLoadPidAI = false;
      this.isAiApiFetch = true;
      this.isShowUpPromotion = false;
      this.isShowUpPromotion = false;

      setTimeout(() => {
        this.isAiApiFetch = false;
      }, 1500);

      // 取得 紫色品
      const data = await this.apis.getTList(this.postData);
      const { pids = [], flag_promo_up = 0, flag_promo_down = 0 } = data || {};

      // 取得 黑區塊商品
      const bData = await this.apis.getAList() || [];
      // 合併商品
      const mergedData = [];
      if (flag_promo_up === 1 && pids.length > 0 && pids[0]) mergedData.push(pids[0]);
      if (Array.isArray(bData)) mergedData.push(...bData);
      if (flag_promo_down === 1 && pids.length > 1 && pids[1]) mergedData.push(pids[1]);

      this.isShowUpPromotion = flag_promo_up === 0;
      this.isShowBottomPromotion = flag_promo_down === 0;

      let pidData = mergedData.map((v) => {
        return Object.assign(v, {
          image_url: v.image_url || '',
          url: this.productPageUrl + v.pid + "?aipc=" + this.aipcParams,
          swipeHint: !v.flag_promo,
        });
      });

      this.originItems = this.items = JSON.parse(JSON.stringify(pidData));

    },
    async getCategoryRec(bid) {
      if (this.isLoadPidAI) return false;
      this.isLoadPidAI = true;

      // 取得 黑區塊商品
      console.log(bid);
      const bData = await this.apis.getAList(bid);

      let items = [];

      // 找到原來的第一中獎品
      if (this.originItems[0].flag_promo) {
        items.push(this.originItems[0]);
      }

      // 組合特定pid的API資料
      items = items.concat(
        bData.map((v) => {
          return Object.assign(v, {
            image_url: v.image_url || '',
          url: this.productPageUrl + v.pid + "?aipc=" + this.aipcParams,
          swipeHint: false,
          });
        })
      );

      // 找到原來的最後中獎品
      if (this.originItems[this.originItems.length - 1].flag_promo) {
        items.push(this.originItems[this.originItems.length - 1]);
      }

      this.items = items;

      this.isShowPidRec = true;
      this.isLoadPidAI = false;
    },
    revertRecItems() {
      this.isShowPidRec = false;
      this.items = this.originItems;
      document.cookie = `AI_HS=${this.originFlaghs
        };path=/;max-age=${86400};domain=.friday.tw;secure`;
    },

    promotionCard(name) {
      return `https://event.shopping.friday.tw/event/turnturn/${name}.png?t=${new Date()
        .toISOString()
        .substr(0, 13)}`;
    },
    resizeImg(src, sid) {
      if (parseInt(sid) === 663) return src;
      return src;
    },
    getMobileCircleFetId(mcw, mcs) {
      const loc = location.hostname;
      const apiDomainEnv = /(turn-uat|localhost)/i.test(loc)
        ? "ec2-muat2"
        : "m";
      const apiPath = `//${apiDomainEnv}.shopping.friday.tw/mobileapi/api/member/fetId?mcw=${mcw}&mcs=${mcs}`;

      fetch(apiPath)
        .then((res) => res.json())
        .then((res) => {
          if (
            res.status === 1 &&
            res.data &&
            res.data[0] &&
            res.data[0].fetId
          ) {
            window.sessionStorage.setItem("mcid", res.data[0].fetId);
            this.mobileCircleFetId = res.data[0].fetId;
            console.log("get mobilecircle fetid success.");
          } else {
            console.log("get mobilecircle fetid fail.");
          }
        })
        .catch(() => {
          console.error("get mobilecircle fetid api fail.");
        });
    },
  },
  computed: {
    winnerPath() {
      let path = location.pathname;
      if (!/\/$/i.test(path)) {
        path += "/";
      }
      return {
        path: path + "winner",
      };
    },
    checkOrderUrl() {
      return this.isMobile
        ? "https://m.shopping.friday.tw/mobileweb/login/otp?WT.me_id=turnturn_AI&device=app&friback=1"
        : "https://shopping.friday.tw/ec2/index.html#otp";
    },
  },
};
</script>

<style lang="scss">
@import "../style/_color.scss";
@import "../style/homepage.scss";
</style>
